import React from 'react';
import AToast from 'antd-mobile/lib/toast';



export default AToast;